<div class="container mt-3 mx-auto">
  @if (!janelas() || janelas().length === 0) {
    <div class="alert alert-info">
      Não foram encontradas janelas com os filtros informados.
    </div>
  } 
  @else {
    <bn-paginacao 
      [total]="atributosPaginacao().count" 
      [opcoesTamanhoPagina]="opcoesPaginacao()" 
      [tamanhoPagina]="atributosPaginacao().pageSize" 
      [numPagina]="atributosPaginacao().page" 
      (tamanhoPaginaChange)="mudarTamanhoPagina($event)" 
      (numPaginaChange)="mudarNumeroPagina($event)"
    >
      <div class="table-responsive">
        <table class="table table-hover fonte">
          <thead>
            <tr >
              <th scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  atributo="id"
                  nomeAtributoExibicao="Id"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  atributo="nomeJanela"
                  nomeAtributoExibicao="Janela de Envio"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  atributo="dataAbertura"
                  nomeAtributoExibicao="Data Abertura"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  atributo="dataFechamento"
                  nomeAtributoExibicao="Data Fechamento"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  atributo="dataInicioProcessamento"
                  nomeAtributoExibicao="Data Início do Processamento"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col">
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            @for (janela of janelasOrdenadas(); track $index) {
              <tr class="fonte" id="pointer">
                <td>{{ janela.id }}</td>
                <td>{{ janela.nomeJanela }}</td>
                <td>{{ janela.dataAbertura | date: 'dd/MM/yyyy' }}</td>
                <td>{{ janela.dataFechamento | date: 'dd/MM/yyyy' }}</td>
                <td>{{ janela.dataInicioProcessamento | date: 'dd/MM/yyyy' }}</td>
                <td>
                  <a class="ms-1" 
                    [routerLink]="['/acompanhamento-batch/pesquisa']"
                    [queryParams]="{nomeJanela: janela.nomeJanela}"  
                  >
                    <i class="fa fa-search" aria-hidden="true" ngbTooltip="Ver processamentos"></i>
                  </a>
                  @if (podeEstender(janela)) {
                    <button class="btn btn-link botao-link" (click)="estender(janela)"
                    >
                      <i class="fa-solid fa-arrows-left-right" [ngbTooltip]="podeEstender(janela) ? 
                        'Permite estender a data máxima de envio de solicitações de honra para esta janela.' : 
                        'Não é possível estender uma janela fechada.'"
                      ></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  }
</div>